import type { ScalesT } from '@mentimeter/question-modules-types';
import { useFlag } from '@mentimeter/flags/confidence/client';
import { usePresentationContext } from '../../legacy-context/presentationContext';
import type { CustomDataT } from './types';
import { NumericalQuestionPresentation } from './NumericalQuestionPresentation';

// We have the same type for controls, copy pasted for now
// Needs to be a type instead of interface as the interface can't satisfy the generic used with useSlideState hook
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type SlideStateNumericalQuestion = { showCorrect?: boolean };

type NumericalQuestionT = ScalesT;

const DEFAULT_CUSTOM_DATA = {
  correct_answer: 7,
  error_margin: 1,
  has_error_margin: false,
  scale: 1,
  display_min: 0,
} as CustomDataT;

export function NumericalQuestionPresentationDataHandler() {
  const {
    useQuestion,
    useResults,
    useSlideState,
    useConfig,
    InteractiveCanvasComponents,
  } = usePresentationContext();
  const question = useQuestion();
  const { results = [] } = useResults<NumericalQuestionT>();
  const [{ showCorrect }] = useSlideState<SlideStateNumericalQuestion>();

  const { mode, enableAnimations } = useConfig();
  const shouldShowCorrect =
    showCorrect || mode === 'idle' || mode === 'screenshot';
  const isScreenshotMode = mode === 'screenshot';

  const {
    correct_answer: correctAnswer,
    error_margin: errorMargin,
    has_error_margin: hasErrorMargin,
    display_min: displayMin,
    scale,
  } = (question.module_custom_data as CustomDataT) || DEFAULT_CUSTOM_DATA;

  const { max } = question.range;

  const { value: isNewLookFlagEnabled } = useFlag(
    'sli-new-look-guess-the-number.enabled',
    false,
  );

  return (
    <NumericalQuestionPresentation
      question={question}
      isScreenshotMode={isScreenshotMode}
      results={results[0]?.score}
      shouldShowCorrect={shouldShowCorrect}
      displayMin={displayMin}
      max={max}
      scale={scale}
      errorMargin={errorMargin}
      hasErrorMargin={hasErrorMargin}
      correctAnswer={correctAnswer}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
      isNewLookFlagEnabled={isNewLookFlagEnabled}
      shouldAnimate={enableAnimations}
    />
  );
}
